<h1 mat-dialog-title>{{ statusMode ? 'Allowance refund status' : 'Refund allowance to team member' }}</h1>
<div mat-dialog-content>
  <span class="teammembername">{{member.email}}</span>
  @if (statusMode) {
    @if (reservation.status === 'AWAITING_LIQUIDITY' || reservation.status === 'REQUESTED') {
      <span class="info">
        ${{(reservation.amountCents / 100).toFixed(2)}} is reserved for refund and cannot be used by the member.
        Stripe funds are not currently available. Wallit administrators have been notified.
        Please wait until you are contacted before retrying.
      </span>
    } @else {
      <span class="info">
        ${{(reservation.amountCents / 100).toFixed(2)}} remains reserved and cannot be used by the member.
        Contact Wallit support before taking further action.
      </span>
    }
    <span class="status">Status: {{ getStatusLabel() }}</span>
  } @else {
    <span class="info">The amount you specify will be refunded from this team member's current allowance balance of ${{displayBalance}}. You will be able to approve the refund before it happens.</span>
    @if (form) {
      <form class="form" [formGroup]="form" padding>
        <mat-form-field>
          <mat-label>Amount to refund ($)</mat-label>
          <input type="number" [max]="balance" matInput placeholder="" formControlName="amount">
        </mat-form-field>
      </form>
    }
  }
</div>
<div class="buttons" mat-dialog-actions>
  @if (statusMode) {
    @if (canManageReservation()) {
      <button mat-raised-button class="donebutton" color="primary" (click)="retryClicked()">Retry Refund</button>
    }
    @if (canManageReservation()) {
      <button mat-button color="warn" (click)="cancelRequestClicked()">Cancel Refund Request</button>
    }
    <button mat-button (click)="onDismiss()">Close</button>
  } @else {
    <button mat-raised-button [disabled]="!form.valid" class="donebutton" color="primary" (click)="refundClicked()">Refund Allowance</button>
    <button mat-button (click)="onDismiss()">Cancel</button>
  }
</div>
